import React, { useState, useEffect } from "react";
import appApi from "../../assets/utils/AppApi";
import BannerSlider from "../../assets/containers/bannerSlider";
import Skeleton from "@mui/material/Skeleton";

function TopBanner() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getTopBanners = async () => {
    try {
      await appApi
        .get(`/banner/getbyposition/Top?page=${1}&limit=999`)
        .then(({ data }) => {
          setData(data.docs);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getTopBanners();
  }, []);

  return (
    <div className="w-100">
      {loading ? (
        <Skeleton
          variant="rounded"
          width={"95%"}
          height={150}
          sx={{ marginInline: "auto", marginBottom: "16px" }}
        />
      ) : (
        <BannerSlider banners={data} />
      )}
    </div>
  );
}

export default TopBanner;
